import { render } from "./background.vue?vue&type=template&id=4ddff203&scoped=true&ts=true"
import script from "./background.vue?vue&type=script&lang=ts"
export * from "./background.vue?vue&type=script&lang=ts"

import "./background.vue?vue&type=style&index=0&id=4ddff203&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddff203"]])

export default __exports__